import { kea } from 'kea'
import PropTypes from 'prop-types'

import twicpicsSource from 'lib/utils/twicpics-source'
import railsContext from 'lib/selectors/rails-context'
import { trimText } from 'lib/utils/trim-text'

const DEFAULT_SCREEN_WIDTH = 1054
const DEFAULT_SCREEN_HEIGHT = 1169
const MAX_AVATAR_WIDTH = 1024
const AVATAR_THUMBNAIL_SIZE = 54
const LARGE_HORIZONTAL_PADDING = 32 * 2
const LARGE_VERTICAL_PADDING = 36 * 2
const MOBILE_VERTICAL_PADDING = 20 * 2
const FOOTER_HEIGHT = 108
const HEADER_MARGIN = 10
const NAVIGATION_WIDTH = 48 * 2
const NAVIGATION_HORIZONTAL_PADDING = 16 * 2

export default kea({
  path: () => ['scenes', 'course', 'profileHeader', 'lightBox'],

  connect: {
    props: [railsContext, ['dpr']]
  },

  actions: () => ({
    setCurrentImage: number => ({ number }),
    closeLightBox: true,
    setDimensions: (width, height) => ({ width, height }),
    openVideo: true,
    closeVideo: true
  }),

  reducers: ({ actions }) => ({
    isVisible: [
      false,
      PropTypes.bool,
      {
        [actions.openVideo]: () => true,
        [actions.closeVideo]: () => false
      }
    ],
    isLightboxOpen: [
      false,
      PropTypes.bool,
      {
        [actions.closeLightBox]: () => false,
        [actions.setCurrentImage]: () => true
      }
    ],
    currentImageNumber: [
      0,
      PropTypes.number,
      {
        [actions.setCurrentImage]: (_, { number }) => Math.max(0, number)
      }
    ],
    screenWidth: [
      0,
      PropTypes.number,
      {
        [actions.setDimensions]: (_, { width }) => width
      }
    ],
    screenHeight: [
      0,
      PropTypes.number,
      {
        [actions.setDimensions]: (_, { height }) => height
      }
    ]
  }),

  selectors: ({ selectors }) => ({
    lightBoxPhotos: [
      () => [(_, props) => props.user, railsContext, selectors.screenHeight, selectors.screenWidth],
      (user, rails) => {
        const { photos, avatarUrl, firstName, screenHeight, screenWidth } = user
        const { dpr } = rails

        const slideMaxHeight =
          screenWidth < 481
            ? (screenHeight || DEFAULT_SCREEN_HEIGHT) - FOOTER_HEIGHT - MOBILE_VERTICAL_PADDING - HEADER_MARGIN
            : (screenHeight || DEFAULT_SCREEN_HEIGHT) - FOOTER_HEIGHT - LARGE_VERTICAL_PADDING - HEADER_MARGIN

        const slideMaxWidth =
          screenWidth < 481
            ? Math.min(screenWidth || DEFAULT_SCREEN_WIDTH, MAX_AVATAR_WIDTH)
            : Math.min(
                (screenWidth || DEFAULT_SCREEN_WIDTH) -
                  LARGE_HORIZONTAL_PADDING -
                  NAVIGATION_WIDTH -
                  NAVIGATION_HORIZONTAL_PADDING,
                MAX_AVATAR_WIDTH
              )

        const lightBoxPhotos = [
          {
            src: twicpicsSource(avatarUrl, slideMaxWidth, slideMaxHeight, dpr),
            thumbnail: twicpicsSource(avatarUrl, AVATAR_THUMBNAIL_SIZE, AVATAR_THUMBNAIL_SIZE, dpr),
            caption: trimText(firstName)
          },
          ...(photos || []).map(photo => ({
            src: twicpicsSource(photo.url, slideMaxWidth, slideMaxHeight, dpr),
            thumbnail: twicpicsSource(photo.url, AVATAR_THUMBNAIL_SIZE, AVATAR_THUMBNAIL_SIZE, dpr),
            caption: photo.title ? trimText(photo.title) : ''
          }))
        ]

        return lightBoxPhotos
      },
      PropTypes.array
    ],
    currentImage: [
      () => [selectors.currentImageNumber, selectors.lightBoxPhotos],
      (currentImageNumber, lightBoxPhotos) => {
        const lightBoxPhotosLength = lightBoxPhotos ? lightBoxPhotos.length : 1

        return currentImageNumber % lightBoxPhotosLength
      },
      PropTypes.number
    ]
  })
})
